import React, { useState } from 'react';
import { Col, Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import CustomSelectInput from '../../../../components/fields/SelectInput/CustomSelectInput';
import { PROCEDURE_TYPE, USER_TYPE, USER_TYPE_LIST } from '../../../../configs';
import ApplicantDTO from '../../../../dto/ApplicantDTO';
import PersonForm from './PersonForm';
import JuridicalForm from './JuridicalForm';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import { addressTransform, quotesTransform } from '../../../../utils/utils';
import SearchInformationBlock from '../SearchInformationBlock';
import FileInput from '../../../../components/fields/FileInput/FileInput';
import CarrierDTO from '../../../../dto/CarrierDTO';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import AddressInput from '../../../../components/fields/Address/AddressInput';
import AutoAcceptApplicant from '../AutoAcceptApplicant';
import Switches from '../../../../components/fields/Switches/Switches';

export default function ApplicantForm(props) {
  const {
    control,
    applicantType,
    availableTypes = USER_TYPE_LIST,
    prefix = '',
    procedure = false,
    formMeta,
    getValues,
    setValue,
    isPreview,
    loadApplication = () => {},
  } = props;
  const dto = new ApplicantDTO();
  const attributes = dto.getAttributesByName();
  const carrierDto = new CarrierDTO({ legal_entity_type: applicantType });
  const carrierAttribute = carrierDto.getAttributesByName();
  const [showSPB, setShowSPB] = useState(false);

  return (
    <>
      <AutoAcceptApplicant
        setValue={setValue}
        procedure={procedure}
        control={control}
        getValues={getValues}
        prefix="applicant."
        loadApplication={loadApplication}
      />
      <SearchInformationBlock getValues={getValues} setValue={setValue} prefix={prefix} procedure={procedure} types={['inn', 'ogrn']} />
      <Row>
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          component={CustomSelectInput}
          dtoObject={attributes.legal_entity_type}
          variant="material"
          withLabel
          options={availableTypes}
          namePrefix={prefix}
        />
      </Row>
      {applicantType === USER_TYPE.PRIVATE_PERSON ? <PersonForm {...props} isPrivatePerson /> : null}
      {applicantType === USER_TYPE.PRIVATE_PERSON_OLD ? <PersonForm {...props} isPrivatePerson /> : null}
      {applicantType === USER_TYPE.LEGAL ? <JuridicalForm {...props} /> : null}
      {applicantType === USER_TYPE.INDIVIDUAL_ENTREPRENEUR ? <PersonForm {...props} isIndividualEntrepreneur /> : null}
      {[USER_TYPE.LEGAL, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType) && !isPreview ? (
        <Row className="row-cols-2">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.commercial_name}
            variant="material"
            namePrefix={prefix}
            transform={quotesTransform}
          />
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={TextInputWithLabel}
            dtoObject={attributes.logo_files}
            variant="material"
            namePrefix={prefix}
            transform={quotesTransform}
          />
        </Row>
      ) : null}
      {[USER_TYPE.PRIVATE_PERSON_OLD, USER_TYPE.PRIVATE_PERSON].includes(applicantType) && (procedure === PROCEDURE_TYPE.PROCEDURE_1227_1) ? (
        <>
          <div className="f4 mt-3">Водительское удостоверение</div>
          <Row className="row-cols-2">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={carrierAttribute.driver_license_series}
              variant="material"
              namePrefix="application_carrier."
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={TextInputWithLabel}
              dtoObject={carrierAttribute.driver_license_number}
              variant="material"
              namePrefix="application_carrier."
            />
          </Row>
          <Row className="row-cols-2">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={DateTimePicker}
              hideTime
              changeFormat="YYYY-MM-DD"
              dtoObject={carrierAttribute.driver_license_issue_date}
              variant="material"
              withLabel
              namePrefix="application_carrier."
            />
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={DateTimePicker}
              hideTime
              changeFormat="YYYY-MM-DD"
              dtoObject={carrierAttribute.driver_license_expiration_date}
              variant="material"
              withLabel
              namePrefix="application_carrier."
            />
            {/* <FieldDTOWithCol */}
            {/*  control={control} */}
            {/*  formMeta={formMeta} */}
            {/*  type="text" */}
            {/*  component={FileInput} */}
            {/*  dtoObject={attributes.driver_license_files} */}
            {/*  variant="material" */}
            {/*  namePrefix="media." */}
            {/*  multiple */}
            {/* /> */}
          </Row>
          <div className="f4 mt-3">Справка о наличии судимости</div>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={carrierAttribute.criminal_record_certificate_info_doc}
              variant="material"
              namePrefix="media."
              multiple
            />
          </Row>
        </>
      ) : null}
      {applicantType === USER_TYPE.LEGAL && (procedure === PROCEDURE_TYPE.PROCEDURE_1228_1) ? (
        <>
          <Row className="row-cols-1">
            <Col>
              <Switches
                type="text"
                variant="material"
                inputProps={{
                  onChange: () => setShowSPB(!showSPB),
                  value: showSPB,
                }}
                label="Филиал (представительство) в Санкт-Петербурге"
              />
            </Col>
          </Row>
          {showSPB && (
          <>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.office_name}
                variant="material"
                namePrefix={prefix}
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={AddressInput}
                dtoObject={attributes.office_legal_address}
                variant="material"
                namePrefix={prefix}
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={AddressInput}
                dtoObject={attributes.office_address}
                label="Адреса местанахождения"
                transform={addressTransform}
                variant="material"
                namePrefix={prefix}
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.office_phone}
                variant="material"
                namePrefix={prefix}
              />
            </Row>
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.office_email}
                variant="material"
                namePrefix={prefix}
              />
            </Row>
          </>
          )}
        </>
      ) : null}
    </>
  );
}
